/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * MDLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {ChangeBiolinkContentOrderBody} from './schemas/change-biolink-content-order-body';

import type {CreateBiolinkLink200} from './schemas/create-biolink-link200';

import type {CreateBiolinkWidgetBody} from './schemas/create-biolink-widget-body';

import type {CreateBiolinkWidget200} from './schemas/create-biolink-widget200';

import type {CreateBiolink200} from './schemas/create-biolink200';

import type {CrupdateBiolinkBody} from './schemas/crupdate-biolink-body';

import type {CrupdateBiolinkLinkBody} from './schemas/crupdate-biolink-link-body';

import type {DeleteBiolinkWidget200} from './schemas/delete-biolink-widget200';

import type {DetachBiolinkLink200} from './schemas/detach-biolink-link200';

import type {ListBiolinksParams} from './schemas/list-biolinks-params';

import type {ListBiolinks200} from './schemas/list-biolinks200';

import type {RetrieveBiolink200} from './schemas/retrieve-biolink200';

import type {UpdateBiolinkAppearanceBody} from './schemas/update-biolink-appearance-body';

import type {UpdateBiolinkAppearance200} from './schemas/update-biolink-appearance200';

import type {UpdateBiolinkLink200} from './schemas/update-biolink-link200';

import type {UpdateBiolinkWidgetBody} from './schemas/update-biolink-widget-body';

import type {UpdateBiolinkWidget200} from './schemas/update-biolink-widget200';

import type {UpdateBiolink200} from './schemas/update-biolink200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all biolinks
 */
export const listBiolinks = (
  params?: ListBiolinksParams,
  options?: SecondParameter<typeof orvalApiFetch<ListBiolinks200>>,
) => {
  return orvalApiFetch<ListBiolinks200>(
    {url: `/biolinks`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a biolink
 */
export const createBiolink = (
  crupdateBiolinkBody?: CrupdateBiolinkBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateBiolink200>>,
) => {
  return orvalApiFetch<CreateBiolink200>(
    {
      url: `/biolinks`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: crupdateBiolinkBody,
    },
    options,
  );
};
/**
 * @summary Retrieve a biolink
 */
export const retrieveBiolink = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveBiolink200>>,
) => {
  return orvalApiFetch<RetrieveBiolink200>(
    {url: `/biolinks/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a biolink
 */
export const updateBiolink = (
  id: number,
  crupdateBiolinkBody?: CrupdateBiolinkBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateBiolink200>>,
) => {
  return orvalApiFetch<UpdateBiolink200>(
    {
      url: `/biolinks/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateBiolinkBody,
    },
    options,
  );
};
/**
 * @summary Delete a biolink
 */
export const deleteBiolink = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/biolinks/${id}`, method: 'DELETE'},
    options,
  );
};
/**
 * @summary Create new link for a biolink
 */
export const createBiolinkLink = (
  biolinkId: number,
  crupdateBiolinkLinkBody?: CrupdateBiolinkLinkBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateBiolinkLink200>>,
) => {
  return orvalApiFetch<CreateBiolinkLink200>(
    {
      url: `/biolink/${biolinkId}/link`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: crupdateBiolinkLinkBody,
    },
    options,
  );
};
/**
 * @summary Update a link for a biolink
 */
export const updateBiolinkLink = (
  biolinkId: number,
  id: number,
  crupdateBiolinkLinkBody?: CrupdateBiolinkLinkBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateBiolinkLink200>>,
) => {
  return orvalApiFetch<UpdateBiolinkLink200>(
    {
      url: `/biolink/${biolinkId}/link/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateBiolinkLinkBody,
    },
    options,
  );
};
/**
 * This will not delete link itself, only remove it from link in bio.
 * @summary Detach a link
 */
export const detachBiolinkLink = (
  biolinkId: number,
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<DetachBiolinkLink200>>,
) => {
  return orvalApiFetch<DetachBiolinkLink200>(
    {url: `/biolink/${biolinkId}/link/${id}/detach`, method: 'POST'},
    options,
  );
};
/**
 * @summary Create a new widget for a biolink
 */
export const createBiolinkWidget = (
  biolinkId: number,
  createBiolinkWidgetBody: CreateBiolinkWidgetBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateBiolinkWidget200>>,
) => {
  return orvalApiFetch<CreateBiolinkWidget200>(
    {
      url: `/biolink/${biolinkId}/widget`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createBiolinkWidgetBody,
    },
    options,
  );
};
/**
 * @summary Update a widget for a biolink
 */
export const updateBiolinkWidget = (
  biolinkId: number,
  widgetId: number,
  updateBiolinkWidgetBody?: UpdateBiolinkWidgetBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateBiolinkWidget200>>,
) => {
  return orvalApiFetch<UpdateBiolinkWidget200>(
    {
      url: `/biolink/${biolinkId}/widget/${widgetId}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: updateBiolinkWidgetBody,
    },
    options,
  );
};
/**
 * @summary Delete a widget
 */
export const deleteBiolinkWidget = (
  biolinkId: number,
  widgetId: number,
  options?: SecondParameter<typeof orvalApiFetch<DeleteBiolinkWidget200>>,
) => {
  return orvalApiFetch<DeleteBiolinkWidget200>(
    {url: `/biolink/${biolinkId}/widget/${widgetId}`, method: 'DELETE'},
    options,
  );
};
/**
 * @summary Change order of biolink content
 */
export const changeBiolinkContentOrder = (
  id: number,
  changeBiolinkContentOrderBody?: ChangeBiolinkContentOrderBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/biolink/${id}/change-order`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: changeBiolinkContentOrderBody,
    },
    options,
  );
};
/**
 * @summary Update appearance
 */
export const updateBiolinkAppearance = (
  id: number,
  updateBiolinkAppearanceBody: UpdateBiolinkAppearanceBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateBiolinkAppearance200>>,
) => {
  return orvalApiFetch<UpdateBiolinkAppearance200>(
    {
      url: `/biolink/${id}/appearance`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: updateBiolinkAppearanceBody,
    },
    options,
  );
};
export type ListBiolinksResult = NonNullable<
  Awaited<ReturnType<typeof listBiolinks>>
>;
export type CreateBiolinkResult = NonNullable<
  Awaited<ReturnType<typeof createBiolink>>
>;
export type RetrieveBiolinkResult = NonNullable<
  Awaited<ReturnType<typeof retrieveBiolink>>
>;
export type UpdateBiolinkResult = NonNullable<
  Awaited<ReturnType<typeof updateBiolink>>
>;
export type DeleteBiolinkResult = NonNullable<
  Awaited<ReturnType<typeof deleteBiolink>>
>;
export type CreateBiolinkLinkResult = NonNullable<
  Awaited<ReturnType<typeof createBiolinkLink>>
>;
export type UpdateBiolinkLinkResult = NonNullable<
  Awaited<ReturnType<typeof updateBiolinkLink>>
>;
export type DetachBiolinkLinkResult = NonNullable<
  Awaited<ReturnType<typeof detachBiolinkLink>>
>;
export type CreateBiolinkWidgetResult = NonNullable<
  Awaited<ReturnType<typeof createBiolinkWidget>>
>;
export type UpdateBiolinkWidgetResult = NonNullable<
  Awaited<ReturnType<typeof updateBiolinkWidget>>
>;
export type DeleteBiolinkWidgetResult = NonNullable<
  Awaited<ReturnType<typeof deleteBiolinkWidget>>
>;
export type ChangeBiolinkContentOrderResult = NonNullable<
  Awaited<ReturnType<typeof changeBiolinkContentOrder>>
>;
export type UpdateBiolinkAppearanceResult = NonNullable<
  Awaited<ReturnType<typeof updateBiolinkAppearance>>
>;
